var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("tool-bar", { attrs: { title: "Submission History" } }),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "page-container", class: _vm.$mq },
        [
          _vm.submissionArray && _vm.submissionArray.length
            ? _vm._l(_vm.submissionArray, function(submission, index) {
                return _c(
                  "v-flex",
                  { key: index, staticClass: "service-log-container" },
                  [
                    _c("history-repeatable", {
                      attrs: { submission: submission },
                      on: { "service-log:deleted": _vm.getSubmissionArray }
                    })
                  ],
                  1
                )
              })
            : [
                _c("v-flex", { staticClass: "font-italic" }, [
                  _vm._v("\n        No Submissions, click\n        "),
                  _c(
                    "span",
                    {
                      staticClass: "secondary--text font-bold",
                      staticStyle: { cursor: "pointer" },
                      on: { click: _vm.goHome }
                    },
                    [_vm._v("\n          here\n        ")]
                  ),
                  _vm._v("\n        to return to the dashboard.\n      ")
                ])
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c("bottom-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19986d8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19986d8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/service-log/history-container.vue
// module id = null
// module chunks = 